import { checkForAppUpdate } from '@/lib/appVersion';
import { applyPendingAppUpdate, refreshServiceWorkerRegistration } from '@/lib/pwaRegister';
import { useCallback, useEffect, useState } from 'react';

export function useAppVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const check = useCallback(async () => {
    const hasUpdate = await checkForAppUpdate();
    setUpdateAvailable(hasUpdate);
    if (hasUpdate) {
      // version.json already says there is a new build; make sure the service worker goes and finds
      // it too, so Reload has a waiting worker to activate instead of re-serving the cached one.
      void refreshServiceWorkerRegistration();
    }
  }, []);

  useEffect(() => {
    void check();
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        void check();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [check]);

  const reload = useCallback(() => {
    void applyPendingAppUpdate();
  }, []);

  return { updateAvailable, reload, check };
}
